import Button from "../components/button"
import { useAuth } from "../contexts/Auth"

const ProfilePage = () => {
  const { signOut } = useAuth()
  return (
    <div className="my-3 flex flex-col gap-3">
      <div className="my-1 text-xl">Profile</div>
      <Button onClick={signOut}>Logout</Button>
    </div>
  )
}

export default ProfilePage
